export const INITIALIZE_FORM = 'AOR/INITIALIZE_FORM';

export const initializeForm = initialValues => ({
    type: INITIALIZE_FORM,
    payload: initialValues,
});



// WEBPACK FOOTER //
// ./src/admin-on-rest/src/actions/formActions.js